import React from 'react';

import { FBMarketplace } from '../../components/store/fb-marketplace';

export const FBMarketplacePagePolaris = () => {
    return <FBMarketplace />;
};
